import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=2299c2fb&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=2299c2fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2299c2fb",
  null
  
)

export default component.exports